// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"ad544517","406":"17b52d6d","436":"80509afb"}[chunkId] + ".css";
};